// @ts-nocheck
const mqStandAlone = "(display-mode: standalone)";

export const useIsInPwa = () => {
    return !!(
        typeof window !== "undefined" &&
        (window.matchMedia(mqStandAlone).matches ||
            ("serviceWorker" in window.navigator && "standalone" in window.navigator && window.navigator?.standalone))
    );
};

export default useIsInPwa;
